import React from 'react';
import isString from 'lodash/isString';

const AddCarrierHeader = ({
	carrier,
	title,
	subtitle,
	isMobile,
	className = '',
	accountNumber,
}) => {
	const carrierCls = carrier.replace(/_/g, '-');
	const carrierLogoName = `${carrierCls}-logo`;

	return (
		<div className={`common-carrier-add-carrier-header ${className}`}>
			<div
				className={carrierLogoName}
				data-qa={carrierLogoName}
				{...{ dataqa: carrierLogoName }}
			/>
			<div className="title">
				<h1 className="primary-header">{title}</h1>
				{/* The below check is done to prevent nested <p> tags, when subtitle is an object instead of a string */}
				{!isMobile && (typeof subtitle === 'object' ? subtitle : <p>{subtitle}</p>)}
			</div>
			{isString(accountNumber) && (
				<div className="account-number">
					{carrier.toUpperCase()} Account #: {accountNumber}
				</div>
			)}
		</div>
	);
};

export default AddCarrierHeader;
